<button
  [ngClass]="[
    variantClasses(),
    buttonSize() === 'default' && style() === 'tertiary'
      ? 'px-4 py-3'
      : buttonSize() === 'small'
        ? 'px-3 py-1'
        : buttonSize() === 'quadratic'
          ? 'px-1 py-1'
          : 'p-input',
  ]"
  [attr.data-context]="context()"
  [attr.data-mode]="mode()"
  [class.tertiary-button]="style() === 'tertiary'"
  [class.enabled:active:outline-1]="
    style() !== 'custom' && style() !== 'tertiary'
  "
  [class.enabled:active:outline-solid]="
    style() !== 'custom' && style() !== 'tertiary'
  "
  [class.rounded-r-none]="flattenRightSide()"
  [class.rounded-l-none]="flattenLeftSide()"
  [disabled]="isDisabled()"
  [type]="type()"
  [id]="id()"
  class="border-box relative flex w-full! cursor-pointer flex-row items-center justify-center rounded-md border-1 text-[1rem] text-nowrap enabled:hover:brightness-88 enabled:active:brightness-76"
  [attr.data-testid]="id() | appendTestId: 'button'">
  <ng-content></ng-content>
  @if (text()) {
    <span class="h-full">{{ text() }}</span>
  }
  @if (isModalButton()) {
    <span class="material-symbols-rounded text-primary-main absolute right-3">
      edit_square
    </span>
  }
  @if (isDisabled()) {
    <span
      (keydown.enter)="$event.preventDefault(); $event.stopPropagation()"
      class="absolute top-0 right-0 bottom-0 left-0"
      tabIndex="0"
      [attr.aria-label]="disabledText()"></span>
  }
</button>
